import { render } from "./FieldReviewScreen.vue?vue&type=template&id=bc549c62"
import script from "./FieldReviewScreen.vue?vue&type=script&lang=js"
export * from "./FieldReviewScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__